var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default direction-ltr",attrs:{"type":"button"},on:{"click":_vm.launchEditor}},[_c('i',{staticClass:"fa-solid fa-scissors"}),_vm._v(" Create Clip\n")])}
var staticRenderFns = []

export { render, staticRenderFns }